import { useTranslation } from 'react-i18next';

import {
  projectsFilterOptionsState,
  selectedProjectsFiltersState,
} from '@/features/projects/project.state';
import { TagsSelect } from '@/components/tag/tags-select';
import { useAtom, useSetAtom } from 'jotai';

export const TagsFilter = () => {
  const { t } = useTranslation('projects');

  const setProjectsFilters = useSetAtom(projectsFilterOptionsState);
  const [selectedFilters, setSelectedFilters] = useAtom(
    selectedProjectsFiltersState,
  );

  return (
    <TagsSelect
      id="filter-tags"
      label={t`projects.tags`}
      defaultValue={selectedFilters.tags}
      onSetOptions={options =>
        setProjectsFilters(currentFilters => ({
          ...currentFilters,
          tags: options,
        }))
      }
      onChange={options =>
        setSelectedFilters(currentFilters => ({
          ...currentFilters,
          tags: options.length ? options : null,
        }))
      }
    />
  );
};
